import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * 定义 Pagination 组件
 */
class Pagination extends PureComponent {
    static propTypes = {
        total: PropTypes.number,
        pageSize: PropTypes.number,
        handleClick: PropTypes.func,
    };

    state = {
        start: 1,
        current: 1,
    };

    handlePageItemClick = (index, end) => {
        const { handleClick } = this.props;
        let start = 1;

        handleClick(index);

        // 处理当前页标签所处分页器中位置
        if (end > 10 && index > 5) {
            const fakeEnd = index + 4;

            if (fakeEnd <= end) {
                start = index - 5;
            } else {
                start = end - 9;
            }
        }

        this.setState({
            start,
            current: index,
        });
    };

    handleArrowClick = (canClick, action, end) => {
        if (canClick) {
            const { current } = this.state;

            this.handlePageItemClick(action === 'pre' ? current - 1 : current + 1, end);
        }
    };

    renderPageItem = (start, end) => {
        const pagesItem = [];
        const { current } = this.state;

        for (let i = start; i <= end && pagesItem.length < 10; i++) {
            pagesItem.push(
                i === current ? (
                    <span key={i} className={styles.curPage}>
                        {i}
                    </span>
                ) : (
                    <a
                        href="javascript:void(0);"
                        key={i}
                        className={styles.pageNum}
                        onClick={() => this.handlePageItemClick(i, end)}>
                        {i}
                    </a>
                ),
            );
        }

        return pagesItem;
    };

    renderPageFlipper = (total, pageSize) => {
        const { start, current } = this.state;
        const pagesNum = Math.ceil(total / pageSize);

        if (pagesNum) {
            return (
                <Fragment>
                    <a
                        href="javascript:void(0);"
                        className={current === 1 ? styles.cantClick : ''}
                        onClick={() => this.handleArrowClick(current !== 1, 'pre', pagesNum)}>
                        &lt;
                    </a>
                    {this.renderPageItem(start, pagesNum)}
                    <a
                        href="javascript:void(0);"
                        className={current === pagesNum ? styles.cantClick : ''}
                        onClick={() => this.handleArrowClick(current !== pagesNum, 'next', pagesNum)}>
                        &gt;
                    </a>
                </Fragment>
            );
        }

        return null;
    };

    /**
     * 渲染组件
     */
    render() {
        const { total, pageSize = 10 } = this.props;

        return <div className={styles.paginationBox}>{this.renderPageFlipper(total, pageSize)}</div>;
    }
}

export default Pagination;
